import React from "react";
import "./Footer.scss";
import { ReactSVG } from "react-svg";
import { Link } from "react-scroll";

function Footer() {
  const currentYear = new Date().getFullYear();
  const copyright = `© ${currentYear} SecondlookOrtho.com`;
  return (
    <div className="footer-landing">
      <div className="main_container">
        <div className="first_div_footer">
          <div className="footer_img">
            <ReactSVG src="/icons/menu/footer-logo.svg" />
          </div>
          <div className="footer_para">
            SecondLook Ortho is HIPAA Compliant and utilizes end-to-end
            encryption to ensure that only you and the person you're
            communicating with can access your photos, video, and documents. We
            don't share or sell personal information.
          </div>
          <div className="social_media">
            <div className="media_item">
              <a href="#">
                <ReactSVG src="/icons/tools/facebook-colored.svg" />
              </a>
            </div>
            <div className="media_item">
              <a href="#">
                <ReactSVG src="/icons/tools/pinterest-colored.svg" />
              </a>
            </div>

            <div className="media_item">
              <a href="#">
                <ReactSVG src="/icons/tools/twitter-colored.svg" />
              </a>
            </div>
          </div>
        </div>
        <div className="sec_div_footer">
          <div className="list_icons">
            <div className="icon_img"></div>
            <div className="list">QUICK LINKS</div>
          </div>
          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="home"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">Home</div>
            </Link>
          </div>
          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="reviews"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">About Us</div>
            </Link>
          </div>

          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="contact-us"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">Contact Us</div>
            </Link>
          </div>
          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="faqs"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">FAQs</div>
            </Link>
          </div>
          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="our-team"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">Our Team</div>
            </Link>
          </div>
          <div className="list_icons">
            <div className="icon_img">
              <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
            </div>
            <Link
              to="how-it-works"
              spy={true}
              smooth={true}
              offset={-95}
              duration={500}
            >
              <div className="list">How it Works</div>
            </Link>
          </div>
        </div>
        <div className="third_div">
          <div className="third_heading">Subscribe to our newsletter</div>
          <div className="parties_3rd">
            We do not share your details with 3rd parties
          </div>
          <div className="addres_div">
            <div className="parties_3rd">Email Address</div>
            <div className="emailInput">
              <input
                className="footer_input"
                text=""
                placeholder="info@company.com"
                style={{ color: "!importantwhite" }}
              />

              <button className="arrow_button">
                <ReactSVG src="/icons/tools/arrow-next.svg" alt="img" />
              </button>
            </div>
          </div>
          <div className="check_box">
            <label className="container">
              I agree to the terms and conditions
              <input type="checkbox" defaultChecked="checked" />
              <span className="checkmark" />
            </label>
          </div>
        </div>
      </div>
      <div className="footer-contact-details">
        <div className="footer-contact-details-item">
          <ReactSVG src="/icons/tools/mail.svg" />
          <a href="mailto:Provider@secondlookortho.com">
            Provider@secondlookortho.com
          </a>
        </div>
        <hr />
        <div className="footer-contact-details-item">
          <ReactSVG src="/icons/tools/phone.svg" />
          <a href="tel:+18008402046">1 (800)840-2046</a>
        </div>
      </div>
      <p className="div_line_p">{copyright}</p>
    </div>
  );
}

export default Footer;
